// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, Button, Input } from 'semantic-ui-react';
import _ from 'lodash';
// local
// views
import Page from 'app/ui/pages/Page';
import AccountModal from 'app/ui/modal/AccountModal';
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
// libs
import t from 'app/lib/i18n';
// consts
import { TYPE as CLIENT_TYPE } from 'salvus-shared/consts/client';
import { PROFILE } from 'salvus-shared/consts/account';
// actions
import { openSave, openUpdate, ACTION, TYPE } from 'app/redux/actions/modal';
import { list, create, update, reset, search } from 'app/redux/actions/account';

class Accounts extends Component {
    constructor(props) {
        super(props);
        this.callSearch = _.debounce(this.callSearch, 100);
        this.state = {
            search: props.account.filter.term,
        };
    }

    // Handler for the change in the input
    onSearchChange = (e, { value }) => {
        this.setState({ search: value });
        this.callSearch(value);
    };

    callSearch = value => this.props.dispatch(search(value));

    componentDidMount = () => this.props.dispatch(list());

    componentWillUnmount = () => this.props.dispatch(reset());

    onClickAdd = () => this.props.dispatch(openSave(TYPE.ACCOUNT));

    onClickEdit = account => () => this.props.dispatch(openUpdate(TYPE.ACCOUNT, account));

    onConfirmModal = (action, form) => {
        if (action === ACTION.ADD) {
            this.props.dispatch(create(form));
        } else if (action === ACTION.UPDATE) {
            this.props.dispatch(update(form.id, form));
        }
    };

    renderEmpty = () => <EmptyList emptyMessage="Nenhum usuário encontrado." />;

    renderTable(auth, filter) {
        return (
            <Table id="list-accounts">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width="1">Mat.</Table.HeaderCell>
                        <Table.HeaderCell width="7">Nome</Table.HeaderCell>
                        <Table.HeaderCell width="1">Perfil</Table.HeaderCell>
                        {auth.account.client.type === CLIENT_TYPE.SALVUS && <Table.HeaderCell width="5">Cliente</Table.HeaderCell>}
                        {!(auth.account.client.type === CLIENT_TYPE.SALVUS && auth.account.profile === PROFILE.DEFAULT) && <Table.HeaderCell width="1" />}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {_.map(filter.data, row => {
                        const { id, name, profile, client } = row;
                        return (
                            <Table.Row key={id}>
                                <Table.Cell width="1">{id}</Table.Cell>
                                <Table.Cell width="7" className="wrap">
                                    {name}
                                </Table.Cell>
                                <Table.Cell width="2">{t(`account_profile_${profile}`)}</Table.Cell>
                                {auth.account.client.type === CLIENT_TYPE.SALVUS && (
                                    <Table.Cell width="5" className="wrap">
                                        {client.name}
                                    </Table.Cell>
                                )}
                                {!(auth.account.client.type === CLIENT_TYPE.SALVUS && auth.account.profile === PROFILE.DEFAULT) && (
                                    <Table.Cell textAlign="right" width="1">
                                        <Button circular icon="edit" onClick={this.onClickEdit(row)} />
                                    </Table.Cell>
                                )}
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        );
    }
    render() {
        const { auth, account } = this.props;
        const { filter, loading } = account;
        return (
            <Page id="page-account" loading={loading}>
                <div className="page-header">
                    <div className="page-title">USUÁRIOS</div>
                    {auth.account.profile !== PROFILE.DEFAULT && <Button content="Adicionar" onClick={this.onClickAdd} />}
                </div>
                <div className="body">
                    <div className="body-header">
                        <Input id="account-search" placeholder="Pesquisar..." className="search" onChange={this.onSearchChange} value={this.state.search} />
                    </div>
                    {_.isEmpty(filter.data) ? this.renderEmpty() : this.renderTable(auth, filter)}
                </div>
                <AccountModal onConfirmModal={this.onConfirmModal} />
            </Page>
        );
    }
}

Accounts.propTypes = {
    auth: PropTypes.object,
    account: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
    account: state.account,
});
export default connect(mapStateToProps)(Accounts);
